import dynamic from 'next/dynamic';
import { colorsV2 } from '../colors-v2';
import styled from 'styled-components';
import { PaginationProps } from 'antd';

export interface Props extends PaginationProps {
  numberPerPage: number;
  pageSizeChange?: (amount: number) => void;
  totalPage: number;
}

export const StyledDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  > .ant-select > .ant-select-selector {
    background-color: transparent !important;
    border: none !important;
  }
  > .ant-select:hover {
    border: none !important;
    background-color: transparent !important;
  }
  > .ant-select:active > .ant-select-selector {
    border: none !important;
    background-color: transparent !important;
  }
  > .ant-select > .ant-select-arrow {
    top: 45%;
  }
  > .ant-pagination {
    > .ant-pagination-options {
      display: none;
    }
    > .ant-pagination-item-active {
      background: ${colorsV2.primary100};
      border-radius: 50%;
      a {
        color: ${colorsV2.white100};
      }
      &:hover {
        background: ${colorsV2.primary80};
      }
      &:focus {
        background: ${colorsV2.primary100};
        color: ${colorsV2.white40};
      }
    }
    > .ant-pagination-item {
      margin-right: 4px;
      &:not(.ant-pagination-item-active) {
        background: ${colorsV2.gray10};
        border-radius: 50%;
        border: none;
        a {
          color: ${colorsV2.black100};
        }
        &:hover {
          background: ${colorsV2.gray20};
        }
        &:focus {
          background: ${colorsV2.gray40};
        }
      }
    }
    > .ant-pagination-next,
    .ant-pagination-prev {
      color: ${colorsV2.black100};
      border: none;
      border-radius: 50%;
      > .ant-pagination-item-link {
        color: ${colorsV2.black100};
      }
      background: transparent;
      button {
        background: transparent;
        border: none;
        border-radius: 50%;
      }
      &:hover {
        background: ${colorsV2.gray40};
      }
      &:active {
        background: ${colorsV2.gray60};
      }
    }
  }
`;

export const DEFAULT_PAGE_SIZE = 10;
export const TESTS_LIST_FOR_BOOK_PAGE_SIZE = 8;
export const PaginationComponent = dynamic<any>(() =>
  import('./PaginationBase').then((mod) => mod.PaginationComponent)
);
export const PaginationComponentWithoutSSR = dynamic<any>(
  () => import('./PaginationBase').then((mod) => mod.PaginationComponent),
  {
    ssr: false,
  }
);
